<template>
<div >
    <p class="title">等待审核</p>
    <div>
        <p>1、所有资料填写完成后，即可按照页面提示信息等待工作人员审核，审核通过后即可进行项目报名和投标。</p>
        <img src="../assets/help/1.1.1-5.png" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>